export const Divider = () => <div className="bg-primary h-px w-full" />;
